import React, { useContext } from "react"
import { Context } from "../../../context/app-context"
import { competitionId } from "../../../constants/activity-constants"
import ActivityService from "../../../services/activity-services"

import imgPersonaHome from "./../../../assets/images/home/persona-home.png"
import imgArrow from "./../../../assets/images/home/arrow-decoration.svg"
import imgSearchIcon from "./../../../assets/images/home/search-icon.svg"
import imgBackgroundPinkDesk from "../../../assets/images/home/decoration-pink-desk.svg"
import Loader from "react-loader-spinner"

import "./home.scss"

export default function Home() { 
  const { dispatch } = useContext(Context)

  const filterOptions = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
  ]

  const [listEmbajadoras, setListEmbajadoras] = React.useState([])
  const [currentPage, setCurrentPage] = React.useState(0)
  const [limitPage, setLimitPage] = React.useState(0)
  const [dataSearch, setDataSearch] = React.useState(null)
  const [activeFilter, setActiveFilter] = React.useState(null)
  const [activeLoader, setactiveLoader] = React.useState(true)

  const filterCandidates = (option, data) => {
    setactiveLoader(true)

    let currentPageCopy = option === 1 || option === 2 ? 0 : currentPage
    let dataSearchCopy = option === 1 ? data : dataSearch
    console.log("filterCandidates -> dataSearchCopy.length", dataSearchCopy)

    ActivityService.getCandidates(
      competitionId,
      dataSearchCopy,
      currentPageCopy,
      10
    )
      .then((res) => {
        if (res.status === 200) {
          if (option === 1 || option === 2) {
            setListEmbajadoras(res.data)
            setCurrentPage(1)

            if (option === 1) {
              setActiveFilter(dataSearchCopy)
            } else {
              setActiveFilter(null)
            }
          } else {
            setListEmbajadoras((e) => e.concat(res.data))
            setCurrentPage((e) => e + 1)
          }

          setLimitPage(res.metadata.limit)
        } else if (res.status === 400) {
          setListEmbajadoras(res.data)
          setActiveFilter(dataSearchCopy)
          setCurrentPage(0)
        }

        setactiveLoader(false)
      })
      .catch((error) => {
        console.log(error)
        setactiveLoader(false)
      })
  }

  const handleToInscription = () => {
    dispatch({
      type: "set-context",
      payload: {
        modalActive: { type: "login" },
      },
    })
  }

  const onChangeSearch = (e) => {
    if (e.target.value === "") {
      setCurrentPage(0)
      filterCandidates(1, "")
      return false
    }

    setDataSearch(e.target.value)
  }

  React.useEffect(() => {
    filterCandidates()
  }, [])

  return (
    <div className="f-embajadoras-home">
      <div className="f-embajadoras-home__container">
      <img
          className="f-background-pink-mobile mobile"
          src={imgBackgroundPinkDesk}
          alt="fondo rosa"
        />

        <div className="f-embajadoras-home__section--left">
          <div className="f-embajadoras-home__title">
            <p className="text-xl">
              ¿Quieres saber{" "}
              <b className="f-decoration-title">si fuiste escogida</b> como una
              de
            </p>
            <h1 className="text-xl--ground text-xl--pink-light">
              Nuestras Embajadoras
            </h1>
            <p className="text-mw">
              de <b>Jabones Íntimos</b> Nosotras?
            </p>
            <b className="f-here-decoration">
              Descúbrelo aquí <img src={imgArrow} alt="flecha" />
            </b>
            <p className="text-xl">
              Busca tu nombre o ingrésalo en el buscador para saber si fuiste
              una de las seleccionadas.{" "}
              <span className="text-xl--blue text-xl--ground f-good-look">
                ¡Mucha suerte!
              </span>
            </p>
          </div>
          <div className="f-embajadoras-home__filters">
            <div className="f-filter-list">
                {filterOptions.map((filter, index) => {
                  return (
                    <b
                      className={
                        "f-filter-item " +
                        (activeFilter !== null &&
                        filter.toLowerCase() === activeFilter.toLowerCase()
                          ? "active"
                          : "")
                      }
                      key={index}
                      onClick={() => {
                        filterCandidates(1, filter === activeFilter ? "" : filter)
                      }}
                    >
                      {filter}
                    </b>
                  )
                })}
              </div>
            <div className="f-searcher-container">
            <input
              type="text"
              autoComplete="off"
              name="filter-name"
              onKeyDown={(e) => e.key == "Enter" && filterCandidates(2)}
              onChange={onChangeSearch}
            />
            <img
              src={imgSearchIcon}
              alt="icono buscador"
              className="search-icon"
              onClick={() => filterCandidates(2)}
            />
          </div>
          </div>
        </div>

        <div className="f-embajadoras-home__img-header desktop">
          <img src={imgPersonaHome} alt="Imagen persona" />
        </div>
      </div>

      {listEmbajadoras && listEmbajadoras.length > 0 && !activeLoader ? (
        <div className="f-embajadoras-home__list">
        <img
          className="f-background-pink desktop"
          src={imgBackgroundPinkDesk}
          alt="fondo rosa"
        />

        <div className="f-embajadora-item  f-header-list desktop">
          <b className="f-title-list">Nombre</b>
          <b className="f-title-list">Correo electrónico</b>
          <b className="f-title-list">Ciudad</b>
        </div>

        {listEmbajadoras.map((embajadora, index) => {
          return (
            <div className="f-embajadora-item" key={index}>
              <b className="mobile">{embajadora.userName}</b>
              <p className="desktop">{embajadora.userName}</p>
              <p>{embajadora.email}</p>
              <p className="f-city">{embajadora.city.toLowerCase()}</p>
            </div>
          )
        })}

        {currentPage < limitPage && (
          <b
            className="text-xl--pink-light f-show-more"
            onClick={filterCandidates}
          >
            Cargar Más
          </b>
        )}
      </div>
      ) : (
        <div className="f-button-container">
          {activeLoader ? (
            <Loader type="TailSpin" color="#FF409B" height={50} width={50} />
          ) : (
            <p className="f-no-result">No se han encontrado resultados</p>
          )}
        </div>
      )}
    </div>
  )
}
